import { catBrowse, stats } from "@/mocks/homeNews";

interface CatBrowseProps {
  onCat: (cat: string) => void;
}

export default function CatBrowse({ onCat }: CatBrowseProps) {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-200 bg-background-50 px-4 py-5 text-center md:px-5">
              <div className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center rounded-full bg-secondary-200/70 px-3 py-1 text-xs font-semibold text-secondary-800">
              栏目速览
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">想吃哪块瓜，直奔哪一栏</h2>
          </div>
          <button
            type="button"
            onClick={() => onCat("全部")}
            className="hidden shrink-0 cursor-pointer whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-600 transition hover:border-primary-400 hover:text-primary-600 md:inline-flex"
          >
            全部速报 <i className="ri-arrow-right-line ml-1" />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {catBrowse.map((it) => (
            <div
              key={it.cat}
              id={`cat-${it.cat}`}
              className="group flex scroll-mt-28 flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-accent-300 md:p-6"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-100 text-xl text-primary-600 transition group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                  <i className={it.icon} />
                </span>
                <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800">
                  <i className="ri-fire-line" /> 热度 {it.heat}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{it.cat}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{it.lead}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {it.topics.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => onCat(it.cat)}
                    className="cursor-pointer rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600 transition hover:bg-accent-100 hover:text-accent-800"
                  >
                    #{t}
                  </button>
                ))}
              </div>
              <button
                type="button"
                onClick={() => onCat(it.cat)}
                className="mt-5 inline-flex cursor-pointer items-center gap-1 self-start text-sm font-semibold text-primary-600 transition hover:gap-2"
              >
                进 {it.cat} 看看 <i className="ri-arrow-right-line" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}